// Thank You 1009 — CU-styled standalone thank-you screen, rendering the exact
// thank-you state of Referral Form 1008 / Influencer Form 1007: white page,
// logo header, the CU banner artwork with the confirmation copy overlaid on it.
// No gradient fields (unlike Thank You 1) because the CU artwork bakes its own
// overlay, and no title/message columns — the heading and paragraph come from
// the rich-text description, which the widget picks per lead source.

export const THANK_YOU_1009_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    logo_image: "",
    logo_alt: "Logo",
    desktop_bg_image: "",
    mobile_bg_image: "",
    alt_image: "Thank you background",
    description: "",
    referral_description: "",
    influencer_description: "",
  },

  THANK_YOU_FIELDS_CONFIG: [
    {
      fieldName: "logo_image",
      label: "Logo Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Logo Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "logo_alt",
      label: "Logo Alt Text",
      value: "Logo",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for logo",
      required: false,
      defaultValue: "Logo",
    },
    {
      fieldName: "desktop_bg_image",
      label: "Desktop Background Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Desktop Background Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_bg_image",
      label: "Mobile Background Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Mobile Background Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_image",
      label: "Background Image Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for background image",
      required: false,
      defaultValue: "Thank you background",
    },
    {
      fieldName: "description",
      label: "Default Description",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder:
        "Heading + message shown by default; leave empty for “Thank You for Applying”",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "referral_description",
      label: "Referral Form Description",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Enter description for users from referral form",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "influencer_description",
      label: "Influencer Form Description",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Enter description for users from influencer form",
      required: false,
      defaultValue: "",
    },
  ],

  METADATA_FIELDS: [],
};
